import { render, staticRenderFns } from "./teacher-wrong.vue?vue&type=template&id=445a3d32&scoped=true"
import script from "./teacher-wrong.vue?vue&type=script&lang=js"
export * from "./teacher-wrong.vue?vue&type=script&lang=js"
import style0 from "./teacher-wrong.vue?vue&type=style&index=0&id=445a3d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a3d32",
  null
  
)

export default component.exports